import { useContext } from 'react';
import { Modal, VerifyEmailAddress } from '@components';
import { ModalContext } from '@context';

import styles from './../modals.module.scss';

export const EmailAddressModal = () => {
	const { showEmailAddressModal, setShowEmailAddressModal } = useContext(ModalContext);
	return (
		<Modal
			customModalStyle={styles['modal-email-address']}
			open={showEmailAddressModal}
			closeable
			handleClose={() => setShowEmailAddressModal(false)}
		>
			<VerifyEmailAddress />
		</Modal>
	);
};
